<template>
  <div
    v-if="pageProfile && ['nestle'].includes(pageProfile.type)"
    class="pa-2 primary lighten-5"
    style="border-radius: 5px"
    :style="{ border: `1px solid ${$vuetify.theme.primary}` }"
  >
    <div class="text-xs-center red--text" v-if="pageProfile.type == 'nestle'">
      <div>สินค้าจะจัดส่ง ในประมาณ 3 วันทำการ</div>

      สำหรับกรุงเทพฯและปริมณฑล และ ประมาณ 5 วันทำการสำหรับต่างจังหวัด
      กรุณาตรวจสอบรายละเอียดสินค้า และ สถานที่จัดส่งให้ถูกต้อง
      ถ้าหากชำระเงินแล้วจะไม่สามารถเปลี่ยนแปลงที่อยู่ได้ภายหลัง
    </div>
  </div>
</template>

<script>
export default {
  props: ['pageProfile']
}
</script>

<style lang="scss" scoped></style>
